module.exports = __webpack_public_path__ + "site/img/227.03acd7cd.jpg";